$('.Rootline__Item--Expandable a').on('click', function () {
  $(this).parents('.Rootline__List').removeClass('Rootline__List--Collapsed');
});
